/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Tim_OsterbuhrInputs */

const en_testimonial_tim_osterbuhr = /** @type {(inputs: Testimonial_Tim_OsterbuhrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great way to listen to papers during my commute. Finally, a voice that doesn't sound like a robot.`)
};

const es_testimonial_tim_osterbuhr = /** @type {(inputs: Testimonial_Tim_OsterbuhrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excelente forma de escuchar artículos durante mi viaje al trabajo. Por fin, una voz que no suena como un robot.`)
};

/**
* | output |
* | --- |
* | "Great way to listen to papers during my commute. Finally, a voice that doesn't sound like a robot." |
*
* @param {Testimonial_Tim_OsterbuhrInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_tim_osterbuhr = /** @type {((inputs?: Testimonial_Tim_OsterbuhrInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Tim_OsterbuhrInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_tim_osterbuhr(inputs)
	return en_testimonial_tim_osterbuhr(inputs)
});